<template>
    <!-- 对话框 -->
    <el-drawer title="更换商家" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <div>
                    商家手机号：
                    <el-input
                        v-model="search_data.phone"
                        placeholder="请输入商家手机号"
                        style="width: 200px; margin-right: 10px"
                        maxlength="11"
                    >
                    </el-input>
                    <!-- <el-button type="primary" icon="el-icon-search" @click="consumerLists">搜索</el-button> -->
                </div>
                <div style="margin-top: 10px; margin-bottom: 500px; margin-left: 26px">
                    联系人：<span>{{ name }}</span>
                </div>

                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center">
                    <el-button type="primary" @click="onSubmitDig">确认</el-button>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-drawer>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.submit_data.business_code = _this.data;
        }
    },
    data() {
        return {
            show: false,
            name: '',

          
            // 表单数据
            submit_data: {
                business_code: '',
                consumer_code: ''
            },
            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                phone: '',
                is_vip: '',
                id_card: '',
                has_order: '',
                car_number: ''
            },
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                },
                phone: {
                    placeholder: '手机号',
                    rules: {
                        required: true,
                        message: '手机号为必填项',
                        regulation: 'eq_str',
                        rulesData: 11
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
      
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.search_data.phone = '';
            _this.name = '';
        },

        // 搜索列表
        consumerLists() {
            _this
                .$post('/consumer/consumerLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    if (res.data.length == 0) {
                        _this.name = '';
                        _this.submit_data.consumer_code = '';
                        this.$message.error('用户手机号不存在，请确认该手机号是否注册九州代驾');
                    } else {
                        _this.name = res.data[0].name;
                        _this.submit_data.consumer_code = res.data[0].consumer_code;
                        _this.editExchangeBusinessConusmer();
                    }
                })
                .catch((err) => {});
        },

        editExchangeBusinessConusmer() {
            _this.$post('/business/editExchangeBusinessConusmer', _this.submit_data).then((res) => {
                _this.$emit('onSubmit');
                _this.closeDialog();
            });
        },

        // 提交
        onSubmitDig() {
            //输入手机号需要点击搜索按钮之后验证手机号是否为系统用户，如果不是系统用户，无法获取consumer_code，需注册才可以
            if (_this.search_data.phone == '') {
                this.$message.error('手机号为必填项');
            } else if (_this.search_data.phone != '') {
                _this.consumerLists();
            }
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}
.item-wrap {
    margin-bottom: 10px;
}
</style>
